import { useQuery, UseQueryResult } from "@tanstack/react-query";
import axios from "axios";
import { enum_api_uri } from "../../../utils/enum";
import { useAuthStore } from "../../../../../console/store/useAuthStore";
import axiosInstance from "../../axiosInstance";

interface CustomerManager {
    customer_manager_idx: number;
    manager_name: string;
    manager_mobile: string;
    manager_email: string;
}

export interface CustomerData {
    customer_idx: number;
    customer_category: number;
    special: boolean;
    customer_name: string;
    reg_date: string;
    customer_manager: CustomerManager | null;
}

interface GetCustomerResponse {
    limit: number;
    current_page: number;
    start_page: number;
    max_page: number;
    last_page: number;
    end_page: number;
    total_count: number;
    data_list: CustomerData[];
}

export const useGetCustomer = (
    page: number,
    pageSize: number,
    search?: string,
    searchtxt?: string,
    field?: string,
    direction?: string,
    status?: boolean | null,
): UseQueryResult<GetCustomerResponse, Error> => {
    const accessToken = useAuthStore(state => state.accessToken);

    return useQuery<GetCustomerResponse, Error>({
        queryKey: ["getCustomerList", page, pageSize, search, searchtxt, field, direction, status],
        queryFn: async () => {
            const statusParam = status !== null && status !== undefined ? `&status=${status}` : "";
            const url = searchtxt
                ? `${enum_api_uri.get_customer}?page=${page}&limit=${pageSize}&search=${search}&searchtxt=${encodeURIComponent(
                      searchtxt,
                  )}&field=${field}&direction=${direction}${statusParam}`
                : `${enum_api_uri.get_customer}?page=${page}&limit=${pageSize}&field=${field}&direction=${direction}${statusParam}`;

            const response = await axiosInstance.get(url, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });
            return response.data.data;
        },
        placeholderData: prevData => {
            if (prevData) {
                return {
                    ...prevData,
                    current_page: page,
                };
            }
            return undefined;
        },
    });
};
